import React from 'react';
import styles from './SellerBuyerInfoSection.module.css';
import { PrimaryButton, PrimaryButtonInline, NamedLink } from '../../../components';

const SellerBuyerInfoSection = () => {
  return (
    <div>
      <section className={styles.mainSection}>
        <h2 className={styles.section_title}>
          How things work
          <NamedLink name='CMSPage' params={{pageId : "frequently-asked-questions"}}>
            {' '}
            <PrimaryButtonInline>FAQs</PrimaryButtonInline>
          </NamedLink>
        </h2>
        <div className={styles.feature_container}>
          <div>
            <h3 className={styles.feature_title}>Buyer</h3>
            <div className={`${styles.feature_box} ${styles.feature_red}`}>
              <div className={styles.feature_number}>01</div>
              <div className={styles.feature_content}>
                <p>Search by keyword and filter with multiple categories.</p>
              </div>
            </div>

            <div className={`${styles.feature_box} ${styles.feature_blue}`}>
              <div className={styles.feature_number}>02</div>
              <div className={styles.feature_content}>
                <p>Make your purchase and the seller will ship the item to you.</p>
              </div>
            </div>

            <div className={`${styles.feature_box} ${styles.feature_yellow}`}>
              <div className={styles.feature_number}>03</div>
              <div className={styles.feature_content}>
                <p>Mark your order as received so the funds can be sent to the seller.</p>
              </div>
            </div>
            <NamedLink name="SearchPage">
              <PrimaryButtonInline>Search listings</PrimaryButtonInline>
            </NamedLink>
          </div>
          <div>
            <h3 className={styles.feature_title}>Seller</h3>
            <div className={`${styles.feature_box} ${styles.feature_red}`}>
              <div className={styles.feature_number}>01</div>
              <div className={styles.feature_content}>
                <p>List your gear for free in minutes.</p>
              </div>
            </div>

            <div className={`${styles.feature_box} ${styles.feature_blue}`}>
              <div className={styles.feature_number}>02</div>
              <div className={styles.feature_content}>
                <p>Accept payments from buyers and ship the item within 14 days.</p>
              </div>
            </div>

            <div className={`${styles.feature_box} ${styles.feature_yellow}`}>
              <div className={styles.feature_number}>03</div>
              <div className={styles.feature_content}>
                <p>
                  Get your money after the buyer receives the order (This may take up to 10 working
                  days).
                </p>
              </div>
            </div>
            <NamedLink name="NewListingPage">
              <PrimaryButtonInline>Post a new listing</PrimaryButtonInline>
            </NamedLink>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SellerBuyerInfoSection;
